<template>
	<div class="select-option flex-center" :class="{'z-crt': selected}">
		<div class="info flex-grow flex-column">
			<div v-if="_events.link" class="flex-center-cross">
				<h5 class="ellipsis" :class="{'z-dis': disabled}" @click.stop="$emit('link')">{{name}}</h5>
				<i class="angle tf-angle-right" @click.stop="$emit('link')"></i>
			</div>
			<h5 v-else class="ellipsis" :class="{'z-dis': disabled}">{{name}}</h5>
			<p v-for="(item, i) in info" :key="i">{{item}}</p>
		</div>
		<div v-if="selected" class="check flex-center"><i class="c-icon-check"></i></div>
		<c-file v-if="image" class="image" :src="image" media @click.native.stop></c-file>
	</div>
</template>

<script>
	export default {
		name: 'selectOption',

		props: {
			name: String,
			info: Array,
			image: String,
			selected: Boolean,
			disabled: Boolean
		}
	}
</script>

<style lang="stylus" scoped>
	.select-option  {
		border-bottom: .01rem solid #eee;
		padding: .24rem .05rem;
		margin: 0 .32rem;

		.info {
			gap: .1rem;

			h5 {
				line-height: .4rem;
				font-size: .3rem;
				font-weight: normal;

				&.z-dis {
					color: #999;
				}
			}

			p {
				line-height: .3rem;
				color: #999;
				font-size: .26rem;
			}

			.angle {
				margin-left: .12rem;
				line-height: .4rem;
				font-size: .24rem;
				color: var(--color-main);
			}
		}

		.image {
			width: .5rem;
			height: .5rem;
			border: none;
			margin-left: .3rem;
			background: #F7F7F7;
		}

		.check {
			margin-left: .3rem;
			font-size: .4rem;
			color: var(--color-main);
		}
	}
</style>
